import styled from "styled-components";
import { UIWidgetsDiv } from "../division/Division";

export const SelectMenuWrapper = styled(UIWidgetsDiv)`
  width: auto;
  position: relative;
  > div {
    position: absolute;
    width: max-content;
    z-index: 10;
    font-size: ${props => props.theme.font14};
    background-color: ${props => props.theme.brandWhite};
    border: 1px solid ${props => props.theme.borderBottom};
    color: ${props => props.theme.lightGrey};
    padding: ${props => props.theme.padding12} ${props => props.theme.padding24};
    top: 155%;
    right: ${props =>
      props.divwrapperrightcss ? props.divwrapperrightcss : "-5px"};
    flex-direction: column;
    justify-content: space-between;
    > div:not(:first-child) {
      border-top: 1px solid ${props => props.theme.greyBorder};
    }
    > div:hover {
      background-color: ${props => props.theme.baseColor};
    }
  }
  > div::before,
  div::after {
    content: "";
    position: absolute;
    border-left: ${props => props.theme.padding12} solid transparent;
    border-right: ${props => props.theme.padding12} solid transparent;
    bottom: 100%;
    right: ${props => (props.pointerrightcss ? props.pointerrightcss : "2px")};
  }
  > div::before {
    border-bottom: ${props => props.theme.padding12} solid
      ${props => props.theme.borderBottom};
  }
  > div::after {
    border-bottom: ${props => props.theme.padding12} solid
      ${props => props.theme.brandWhite};
    margin-bottom: -2px;
    z-index: 10;
  }
`;
export const SelectMenuItemWrapper = styled(UIWidgetsDiv)`
  cursor: pointer;
  width: 100%;
  padding: 5px 0;
  text-align: left;
`;
